module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M32 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V2zM20 21.348c0 .592-.604.822-1.102.52l-8.826-5.318c-.498-.302-.546-.796-.048-1.1l8.898-5.318c.498-.302 1.078-.07 1.078.522v10.694z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/left-square-1.js
// module id = 1224
// module chunks = 14